import type { RgbToCss } from "./types";

export const rgbToCss: RgbToCss = ([r, g, b]) => `rgb(${r}, ${g}, ${b})`;
